import { OrganizationInternalOwnerEntity } from '../entities/entities.types';
import { AppState } from '../root.reducer';

export const getOrganizationInternalOwners = (state: AppState, organizationId: string): OrganizationInternalOwnerEntity[] => {
  if (!state.entities.organizationInternalOwner) return [];
  if (!organizationId) return [];

  return state.organizationInternalOwner.organizationInternalOwners
    .map((id) => state.entities.organizationInternalOwner[id])
    .filter((item): item is OrganizationInternalOwnerEntity => Boolean(item) && item.organizationId === organizationId);
};
